import { MarkerClusterer } from "@googlemaps/markerclusterer";
import 'jquery-ui-dist/jquery-ui.min.js'
window.stockistsGMaps = {};
(function (mapApp) {
    var map = null,
        _lat = -24.886436,
        _lng = 134.077148,
        _zoom = 5,
        autocomplete = null,
        markers = [],
        reorderDisabled = false,
        fitBounds = true,
        enableGeolocation = $("#stockists-map").data("enablegeolocation"),
        markerColour = "#000000",
        markerCluster = null,
        located = false,
        recalculateDistances = false,
        Popup,
        popup;

    if ($(".js-stockists-list").data("culture").length) {
        var culture = $(".js-stockists-list").data("culture");
        if (culture && culture.includes("NZ")) {
            _lat = -41.278423;
            _lng = 174.776692;
        }
    }

    mapApp.init = function () {
        map = new google.maps.Map($("#stockists-map")[0],
            {
                center: new google.maps.LatLng(_lat, _lng),
                zoom: _zoom,
                styles: [{
                    stylers: [{
                        saturation: -85
                    }]
                }]
            });

        // This event is fired when the map becomes idle after panning or zooming.
        google.maps.event.addListener(map, 'idle', handleMapIdle);

        Popup = createPopupClass();

        populateMarkers();

        autocomplete = new google.maps.places.Autocomplete(
            $(".js-location-autocomplete")[0],
            {
                types: ['geocode']
            });
        autocomplete.addListener('place_changed', mapApp.autocompletePicked);

        // prompt browser for location
        if (enableGeolocation && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(mapApp.geoLocated);
        }
    };

    mapApp.setCentre = function (lat, lng) {
        _lat = lat;
        _lng = lng;
        map === null || map.setCenter(new google.maps.LatLng(_lat, _lng));
    };

    mapApp.setZoom = function (zoom) {
        _zoom = zoom;
        map === null || map.setZoom(_zoom);
    };

    mapApp.geoLocated = function (position) {
        located = true;
        recalculateDistances = true;
        mapApp.setCentre(position.coords.latitude, position.coords.longitude);
        mapApp.setZoom(12);
    };

    mapApp.autocompletePicked = function () {
        var place = autocomplete.getPlace();
        located = true;
        recalculateDistances = true;
        mapApp.setCentre(place.geometry.location.lat(), place.geometry.location.lng());
        mapApp.setZoom(12);
    };

    mapApp.panToMarker = function ($locationItem) {
        if ($locationItem.data("lat") === "" || $locationItem.data("lng") === "") {
            return;
        }

        var locationLatLng = new google.maps.LatLng($locationItem.data("lat"), $locationItem.data("lng"));
        $.each(markers,
            function () {
                if (locationLatLng.equals(this.getPosition())) {
                    reorderDisabled = true;
                    map.panTo(this.getPosition());
                    return;
                }
            });
    };

    // private functions
    function populateMarkers() {
        var bounds = new google.maps.LatLngBounds();
        $(".js-location-item").each(function () {
            if ($(this).data("lat") !== "" && $(this).data("lng") !== "") {
                var position = new google.maps.LatLng($(this).data("lat"), $(this).data("lng"));
                var marker = new google.maps.Marker({
                    position: position,
                    icon: markerSymbol(markerColour),
                    stockistId: $(this).attr("id"),
                    isInCluster: true,
                    stockist: $(this).data("stockist")
                });

                google.maps.event.addListener(marker, 'click', function () { markerClick(marker) });

                markers.push(marker);

                bounds.extend(position);
            }
        });

        const renderer = {
            render({ count, position }) {
                return new google.maps.Marker({
                    label: { text: String(count), color: "white", fontSize: "12px", width: 40, height: 40 },
                    position,
                    icon: getGoogleClusterInlineSvg(markerColour)
                });
            }
        }

        markerCluster = new MarkerClusterer({ map, markers, renderer });

        if (fitBounds) {
            reorderDisabled = true;
            map.fitBounds(bounds);
        }
    }

    function markerSymbol(color) {
        return {
            path: 'M160,0C71.641,0,0,71.625,0,160c0,24.75,5.625,48.219,15.672,69.125 C16.233, 230.313,160,512,160,512l142.594-279.375C313.719, 210.844,320,186.156,320,160C320, 71.625,248.375,0,160,0',
            anchor: new google.maps.Point(160, 512),
            fillColor: color,
            fillOpacity: 1,
            scale: 0.09
        };
    }

    function getGoogleClusterInlineSvg(color) {
        // https://stackoverflow.com/questions/28178080/getting-google-map-markerclusterer-plus-icons-in-one-color/37302915#37302915
        var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="40" width="40"><circle cx="20" cy="20" r="20" fill="' + color + '"></circle></svg>');
        return ('data:image/svg+xml;base64,' + encoded);
    }

    function markerClick(marker) {
        var stockistId = marker.stockistId;
        var $stockistItem = $("#" + stockistId);
        $stockistItem.find(".js-stockist-view-btn").click();
        var $list = $(".js-stockists-list");
        $list.animate({ scrollTop: $list.scrollTop() + ($stockistItem.offset().top - $list.offset().top) });
        showPopup(marker);
    }

    function showPopup(marker) {
        removePopupFromMap();
        var content = document.createElement('div');
        content.innerHTML = '<div class="info-window">' + formatStockist(marker.stockist) + '</div>';
        popup = new Popup(marker.position, content);
        popup.setMap(map);
    }

    function closePopup(event) {
        if (event) { event.preventDefault(); }
        removePopupFromMap();
    }

    function removePopupFromMap() {
        if (popup) {
            popup.setMap(null);
        }
    }

    function formatStockist(stockist) {
        const websiteLink = stockist.Website.toLowerCase().startsWith("http") ? stockist.Website : `//${stockist.Website}`;
        const innerHtml = '<div class="event-panel__inner js-outlet" data-id="' + stockist.Id + '" style="border: none; max-width: 300px">' +
            '<h4 class="stockist-name">' + stockist.Name + '</h4>' +
            (stockist.Address ? '<div class="event-panel__group">' + stockist.Address + '</div>' : "") +
            (stockist.AddressLine ? '<div class="event-panel__group">' + stockist.AddressLine + '</div>' : "") +
            '<br/>' +
            (stockist.Phone ? '<a href="tel:' + stockist.PhoneLink + '" target="_blank">' + stockist.Phone + '</a><br/>' : "") +
            (stockist.Email ? '<a href="mailto:' + stockist.Email + '" target="_blank">' + stockist.Email + '</a><br/>' : "") +
            (stockist.Website ? '<a href="' + websiteLink + '" target="_blank">' + stockist.Website + '</a>' : "") +
            '</div>';
        return innerHtml;
    }

    function handleMapIdle() {
        // check if the centre of the map has changed
        var currentMapCentre = map.getCenter();
        if (currentMapCentre.lat !== _lat || currentMapCentre.lng !== _lng) {
            _lat = currentMapCentre.lat;
            _lng = currentMapCentre.lng;

            // don't reorder the listings if the panning happened because a location was selected in the list
            if (reorderDisabled) {
                reorderDisabled = false;
                return;
            }

            reorderListings();
        }
    }

    // reorder listings by proximity to map centre
    function reorderListings() {
        var currentMapCentre = map.getCenter();
        $(".js-location-item").each(function () {
            if ($(this).data("lat") !== "" && $(this).data("lng") !== "") {
                var distance = google.maps.geometry.spherical.computeDistanceBetween(currentMapCentre,
                    new google.maps.LatLng($(this).data("lat"), $(this).data("lng")));
                $(this).data("geodistance", distance);
                if (located && recalculateDistances) {
                    var pathname = window.location.pathname; // Returns path only (/path/example.html)
                    var arr = pathname.split('/');
                    var culture = arr[1];
                    var distKm = parseFloat(distance / 1000.0).toFixed(2) + "km";
                    var distMiles = parseFloat(distance / 1621.4).toFixed(2) + "mi";
                    $(this).find(".distance").removeClass("hide").text(culture === 'us' ? distMiles : distKm);
                }
            } else {
                // set to large number to put these at the bottom.
                // 25 million meters is more than half the circumference of the earth,
                // so will always be larger than actual distances.
                $(this).data("geodistance", 25000000);
                $(this).find(".distance").addClass("hide");
            }
        });
        recalculateDistances = false;

        $(".js-location-item").sort(function (a, b) {
            if ($(a).data('geodistance') > $(b).data('geodistance')) {
                return 1;
            }
            if ($(a).data('geodistance') < $(b).data('geodistance')) {
                return -1;
            }
            return 0;
        }).appendTo(".js-stockists-list");
    }

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(processPosition);
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }

    function processPosition(position) {
        var locationLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        map.setZoom(10);
        map.panTo(locationLatLng);
    }

    /**
     * Returns the custom Popup class
     * @returns {Popup} Popup class
     * https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
     * Unfortunately, the Popup class can only be defined after
     * google.maps.OverlayView is defined, when the Maps API is loaded.
     * This function should be called by initMap.
     */
    function createPopupClass() {
        /**
         * A customized popup on the map.
         * @param {!google.maps.LatLng} position The map position
         * @param {!string} contentString The HTML string containing the popup markup
         * @constructor
         * @extends {google.maps.OverlayView}
         */
        function Popup(position, content) {

            this.position = position;
            content.classList.add('map-popup');

            var closeButton = document.createElement('button');
            closeButton.classList.add('map-popup__button');
            closeButton.innerHTML = '<svg class="icon icon-close" role="presentation" aria-hidden="true"><use xlink:href="#icon-close"></use></svg><span class="screen-reader-text">Close</span>';
            content.appendChild(closeButton);

            this.containerDiv = document.createElement('div');
            this.containerDiv.classList.add('map-popup-container');
            this.containerDiv.appendChild(content);

            // Optionally stop clicks, etc., from bubbling up to the map.
            //google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
        }
        // ES5 magic to extend google.maps.OverlayView.
        Popup.prototype = Object.create(google.maps.OverlayView.prototype);

        /** Called when the popup is added to the map. */
        Popup.prototype.onAdd = function () {
            this.getPanes().floatPane.appendChild(this.containerDiv);

            // This handler allows right click events on anchor tags within the popup
            var allowAnchorRightClicksHandler = function (e) {
                if (e.target.nodeName === "A") {
                    e.cancelBubble = true;
                    if (e.stopPropagation) {
                        e.stopPropagation();
                    }
                }
            };
            this.contextListener = google.maps.event.addDomListener(this.containerDiv, "contextmenu", allowAnchorRightClicksHandler);

            // pan the map so the marker and popup are visible
            var containerPosition = this.containerDiv.getBoundingClientRect();
            var positionPoint = this.getProjection().fromLatLngToDivPixel(this.position);
            // get the coordinate at the point, add half the width of the popup plus a margin to the x position
            var shiftedLatLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(positionPoint.x + containerPosition.width / 2 + 15, positionPoint.y));
            this.map.panTo(shiftedLatLng);
        };

        /** Called when the popup is removed from the map. */
        Popup.prototype.onRemove = function () {
            if (this.contextListener) {
                google.maps.event.removeListener(this.contextListener);
                this.contextListener = null;
            }
            if (this.containerDiv.parentElement) {
                this.containerDiv.parentElement.removeChild(this.containerDiv);
            }
        };

        /** Called each frame when the popup needs to draw itself. */
        Popup.prototype.draw = function () {
            var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

            // Hide the popup when it is far out of view.
            var display =
                Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
                    'block' :
                    'none';

            if (display === 'block') {
                this.containerDiv.style.left = divPosition.x + 'px';
                this.containerDiv.style.top = divPosition.y + 'px';
            }
            if (this.containerDiv.style.display !== display) {
                this.containerDiv.style.display = display;
            }
        };

        return Popup;
    }

    $(document).ready(function () {


        var hash = window.location.hash;
        $(".js-tab-where-to-buy").tabs()
        if (hash == '#buy-online') {
            $(".js-tab-where-to-buy").tabs("option", "active", 1);
        }
        $(".js-use-my-location").on("click", function (e) {
            e.preventDefault();
            getLocation();
        });

        $(".js-stockists-list").on("click", ".js-stockist-view-btn", function (e) {
            var target = $(e.target);
            if (target.is("a") && target.attr("href") !== "#") { // exclude clicks on a tags inside location-item
                return true;
            }
            e.preventDefault();
            var $listItem = $(this).closest(".js-location-item");
            $(".js-location-item").not($listItem).removeClass("is-active");
            $listItem.addClass("is-active");
            stockistsGMaps.panToMarker($listItem);

            if ($(window).width() < 741) {
                $("html, body").animate({ scrollTop: $(".stockists-map-container").offset().top - $("header").outerHeight() }, 1200);
            }
            removePopupFromMap();
        });

        $(document).on("click", ".map-popup__button", closePopup);

    });

})(stockistsGMaps);
